import lodash from 'lodash';
import 'simplebar';
import 'simplebar/dist/simplebar.min.css';
import { COMMON } from './common';
import { Home } from './page/Home';
import { Tpics } from './page/Tpics';
import { Data } from './page/Data';
import Alpine from 'alpinejs'

window.Alpine = Alpine

/**
 * 現在の階層からルートへの相対距離を計算し、パスを補完して要素を差し替える
 */
const replaceElementWithHTML = async (selector, relativePath, isEvent = false) => {
  const target = document.querySelector(selector);
  if (!target) return;

  const finalPath = target.dataset.path + relativePath;

  try {
    const response = await fetch(finalPath);
    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

    const htmlContent = await response.text();
    const replaceHtml = htmlContent.replaceAll('<% path %>', target.dataset.path);

    target.insertAdjacentHTML('afterend', replaceHtml);
    target.remove();

    if (isEvent) {
      document.dispatchEvent(new CustomEvent('html:Included', { detail: { selector } }));
    }
  } catch (error) {
    console.error(`[Load Error] Path: ${finalPath}`, error);
  }
};

(function () {
  window.addEventListener('DOMContentLoaded', async() => {
    await replaceElementWithHTML('#Footer', 'include/footer.html',false);
    await replaceElementWithHTML('#InterviewArea', 'include/interviewArea.html',false);
    await replaceElementWithHTML('#Header', 'include/header.html',true);
    Alpine.start();
  });
  document.addEventListener('html:Included', () => {
    COMMON.init();
    Home.init();
    Tpics.init();
    Data.init();
  });
  window.addEventListener(
    'resize',
    (lodash.debounce = () => {
      COMMON.resize();
      Data.resize();
    })
  );
})();
